










import Vue from 'vue';
import { mapState } from 'vuex';
import AppHeader from '../components/AppHeader.vue';

export default Vue.extend({
  name: 'ViewDashboard',
  components: {
    AppHeader,
  },
  computed: {
    ...mapState(['starWars']),
  },
  mounted(): void {
    this.$store.dispatch('starWars/getProtagonist');
  },
});
